import React from 'react';
import { observer } from 'mobx-react-lite';
import { BetShopHeaderSection } from '../betShopHeaderSection';
import { BetShopActionPanel } from '../betShopActionPanel';
import { BetShopStatistics } from '../betShopStatistics';

export const BetShopFirstView = observer(() => {
  return (
    <div className='bb-desktop-one'>
      <BetShopHeaderSection />
      <BetShopActionPanel />
      <BetShopStatistics />
    </div>
  );
});
